export default __webpack_public_path__ + "static/media/code_runner.4cb7b575.png";